import { Body, Icon, LineSeparator, useTheme } from "@merit/frontend-components";
import { FlatList } from "react-native-gesture-handler";
import { Header } from "@src/components";
import { ScrollView, StyleSheet, View } from "react-native";
import { useConfig, useFeatureFlags, useNavigation } from "@src/hooks";
import type { TextStyle, ViewStyle } from "react-native";

export const FeatureFlagsInfo = () => {
  const { theme } = useTheme();
  const styles = StyleSheet.create<{
    readonly container: ViewStyle;
    readonly content: ViewStyle;
    readonly label: TextStyle;
    readonly value: TextStyle;
  }>({
    container: {
      backgroundColor: theme.colors.background.white,
      flex: 1,
    },
    content: {
      padding: theme.spacing.l,
      rowGap: theme.spacing.xxl,
    },
    label: {
      ...theme.fontSizes.l,
      fontWeight: theme.fontWeights.semiBold,
      marginBottom: theme.spacing.s,
    },
    value: {
      ...theme.fontSizes.m,
      paddingLeft: theme.spacing.s,
    },
  });

  const nav = useNavigation();
  const config = useConfig();
  const flags = useFeatureFlags();

  return (
    <View style={styles.container}>
      <Header
        leftElement={<Icon name="chevronLeftMediumAction" />}
        leftOnPress={() => {
          nav.goBack();
        }}
        title="Feature Flags"
        titleBold
        titleLevel="3"
      />
      <ScrollView contentContainerStyle={styles.content}>
        <View>
          <Body style={styles.label}>Feature Flag Provider</Body>
          <Body style={styles.value}>{config.featureFlags.provider}</Body>
        </View>
        <LineSeparator />
        <View>
          <FlatList
            data={Object.entries(flags)}
            renderItem={({ item: [flagName, flagValue] }) => (
              <View>
                <Body style={styles.label}>{flagName}</Body>
                <Body style={styles.value}>{String(flagValue)}</Body>
              </View>
            )}
            scrollEnabled={false}
          />
        </View>
      </ScrollView>
    </View>
  );
};
